import types from "./types";

const INITIAL_STATE = {
	fromBuilder: null,

	fromBuilderError: null,
	fromBuilderLoading: false,

	//create
	createFromBuilder: null,
	createFromBuilderError: null,
	createFromBuilderLoading: false,

	//update
	updateFromBuilder: null,
	updateFromBuilderError: null,
	updateFromBuilderLoading: false,

	//delete
	deleteFromBuilder: null,
	deleteFromBuilderError: null,
	deleteFromBuilderLoading: false,

	//single item

	singleItem: null,
	singleItemError: null,
	singleItemLoading: false,

	//select item

	selectItem: null,

	//form by title
	formByTitle: null,
	formByTitleError: null,
	formByTitleLoading: false,

	//forms by title (keyed: { normalizedTitle: form })
	formsByTitle: {},
	formsByTitleError: null,
	formsByTitleLoading: false,
};

const FromReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_FROMBUILDER_START:
			return {
				...state,
				fromBuilder: null,
				fromBuilderError: null,
				fromBuilderLoading: true,
			};
		case types.GET_FROMBUILDER_SUCCESS:
			return {
				...state,
				fromBuilder: action.payload,
				fromBuilderLoading: false,
			};
		case types.GET_FROMBUILDER_ERROR:
			return {
				...state,
				fromBuilderError: action.payload,
				fromBuilderLoading: false,
			};
		case types.GET_FROMBUILDER_RESET:
			return {
				...state,
				fromBuilderError: null,
				fromBuilderLoading: false,
			};
		//create

		case types.CREATE_FROMBUILDER_START:
			return {
				...state,
				createFromBuilder: null,
				createFromBuilderError: null,
				createFromBuilderLoading: true,
			};
		case types.CREATE_FROMBUILDER_SUCCESS:
			return {
				...state,
				createFromBuilder: action.payload,
				createFromBuilderLoading: false,
			};
		case types.CREATE_FROMBUILDER_ERROR:
			return {
				...state,
				createFromBuilderError: action.payload,
				createFromBuilderLoading: false,
			};
		case types.CREATE_FROMBUILDER_RESET:
			return {
				...state,
				createFromBuilder: null,
				createFromBuilderError: null,
				createFromBuilderLoading: false,
			};
		//delete

		case types.DELETE_FROMBUILDER_START:
			return {
				...state,
				deleteFromBuilder: null,
				deleteFromBuilderError: null,
				deleteFromBuilderLoading: true,
			};
		case types.DELETE_FROMBUILDER_SUCCESS:
			return {
				...state,
				deleteFromBuilder: action.payload,
				deleteFromBuilderLoading: false,
			};
		case types.DELETE_FROMBUILDER_ERROR:
			return {
				...state,
				deleteFromBuilderError: action.payload,
				deleteFromBuilderLoading: false,
			};
		case types.DELETE_FROMBUILDER_RESET:
			return {
				...state,
				deleteFromBuilder: null,
				deleteFromBuilderError: null,
				deleteFromBuilderLoading: false,
			};

		//update
		case types.UPDATE_FROMBUILDER_START:
			return {
				...state,
				updateFromBuilder: null,
				updateFromBuilderError: null,
				updateFromBuilderLoading: true,
			};
		case types.UPDATE_FROMBUILDER_SUCCESS:
			return {
				...state,
				updateFromBuilder: action.payload,
				updateFromBuilderLoading: false,
			};
		case types.UPDATE_FROMBUILDER_ERROR:
			return {
				...state,
				updateFromBuilderError: action.payload,
				updateFromBuilderLoading: false,
			};
		case types.UPDATE_FROMBUILDER_RESET:
			return {
				...state,
				updateFromBuilder: null,
				updateFromBuilderError: null,
				updateFromBuilderLoading: false,
			};
		//singleItem
		case types.SINGLE_FROMBUILDER_START:
			console.log("Hello ==========++>")
			return {
				...state,
				singleItem: null,
				singleItemError: null,
				singleItemLoading: true,
			};
		case types.SINGLE_FROMBUILDER_SUCCESS:
			return {
				...state,
				singleItem: action.payload,
				singleItemLoading: false,
			};
		case types.SINGLE_FROMBUILDER_ERROR:
			return {
				...state,

				singleItemError: action.payload,
				singleItemLoading: false,
			};
		case types.SINGLE_FROMBUILDER_RESET:
			return {
				...state,
				singleItem: null,
				singleItemError: action.payload,
				singleItemLoading: false,
			};

		case types.SELECT_TOUPDATE_ITEM:
			return {
				...state,
				selectItem: action.payload,
			};

		//form by title
		case types.GET_FORM_BY_TITLE_START:
			return {
				...state,
				formByTitle: null,
				formByTitleError: null,
				formByTitleLoading: true,
			};
		case types.GET_FORM_BY_TITLE_SUCCESS:
			return {
				...state,
				formByTitle: action.payload,
				formByTitleLoading: false,
			};
		case types.GET_FORM_BY_TITLE_ERROR:
			return {
				...state,
				formByTitleError: action.payload,
				formByTitleLoading: false,
			};
		case types.GET_FORM_BY_TITLE_RESET:
			return {
				...state,
				formByTitle: null,
				formByTitleError: null,
				formByTitleLoading: false,
			};

		//forms by title (keyed) - merge so multiple pages/forms coexist
		case types.GET_FORMS_BY_TITLE_START:
			return {
				...state,
				formsByTitleError: null,
				formsByTitleLoading: true,
			};
		case types.GET_FORMS_BY_TITLE_SUCCESS:
			return {
				...state,
				formsByTitle: { ...state.formsByTitle, ...action.payload },
				formsByTitleLoading: false,
			};
		case types.GET_FORMS_BY_TITLE_ERROR:
			return {
				...state,
				formsByTitleError: action.payload,
				formsByTitleLoading: false,
			};
		case types.GET_FORMS_BY_TITLE_RESET:
			return {
				...state,
				formsByTitle: {},
				formsByTitleError: null,
				formsByTitleLoading: false,
			};

		default:
			return { ...state };
	}
};

export default FromReducer;
